import axios from 'axios';
import {api} from '../../constants/api';
import {showGlobalErrorMessage} from '../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';
import {errors} from '../../../../common/constants/errors';

export const uploadFile = (file, payload = {}) => {
  const {shumaId, filename, fileTypeId, fileToSave, folderID = null} = file;
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append('fileToSave', fileToSave);
      formData.append('shumaID', shumaId);
      formData.append('fullFileName', filename);
      formData.append('fileTypeID', fileTypeId);
      formData.append('folderID', folderID);
      Object.keys(payload).forEach(key => {
        formData.append(`${key}`, payload[key]);
      });

      const response = await axios.post(
        api.UPLOAD_FILE,
        formData,
        {headers: {'Content-Type': 'multipart/form-data'}}
      )
      if (response.data.errorCode === -3) {
        console.log(`File ${filename} already exists`);
        await showGlobalErrorMessage(errors.FILE_ALREADY_EXISTS)(dispatch);
      } else if (response.data.errorCode === -1) {
        await showGlobalErrorMessage(errors.SERVER_ERROR)(dispatch);
      }
    } catch (err) {
      console.error('uploadFile returns error:');
      console.error(err);
    }
  };
};

export const editFile = (file, payload = {}) => {
  const {shumaId, fileID, filename, fileTypeId, fileToSave, folderID = null, freeID, freeText} = file;
  return () => {
    const formData = new FormData();
    formData.append('fileToSave', fileToSave);
    formData.append('shumaID', shumaId);
    formData.append('fileID', fileID);
    formData.append('fullFileName', filename);
    formData.append('fileTypeID', fileTypeId);
    formData.append('folderID', folderID);
    formData.append('freeID', freeID);
    formData.append('freeText', freeText);
    Object.keys(payload).forEach(key => {
      formData.append(`${key}`, payload[key]);
    });

    return axios.post(api.EDIT_FILE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .catch((err) => {
        console.error('editFile returns error:');
        console.error(err);
      });
  };
};

export const editOrderFile = (file, payload = {}) => {
  const {orderID, fileID, filename, fileTypeId, fileToSave, orderFileTypeID} = file;
  return () => {
    const formData = new FormData();
    formData.append('fileToSave', fileToSave);
    formData.append('orderID', orderID);
    formData.append('fileID', fileID);
    formData.append('fullFileName', filename);
    formData.append('fileTypeID', fileTypeId);
    formData.append('orderFileTypeID', orderFileTypeID);
    Object.keys(payload).forEach(key => {
      formData.append(`${key}`, payload[key]);
    });

    return axios.post(api.EDIT_ORDER_FILE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .catch((err) => {
        console.error('editFile returns error:');
        console.error(err);
      });
  };
};
